export default {"src":"/_next/static/media/tableSearch.afc5e0b7.svg","height":11,"width":11};